import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  updateVisitDetail,
  getPatientVisitDetails,
  updateVisitData,
} from "../../actions/patientActions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const NotesEditor = ({ currentIndex, editing }) => {
  const params = useParams();
  const dispatch = useDispatch();
  const { visitDetails } = useSelector((state) => state.patientVisitDetails);
  const token = useSelector((state) => state.loginData.token);

  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const visit = visitDetails?.data?.[currentIndex];

  useEffect(() => {
    if (visit?.visit_note) {
      setNote(visit.visit_note);
    } else {
      setNote("");
    }
  }, [visitDetails]);

  const handleSave = async () => {
    if (!visit?.id) {
      toast.error("Invalid visit record");
      return;
    }

    setSaving(true);
    try {
      await dispatch(
        updateVisitData(token, visit.patient_visit, { visit_note: note })
      );
      // await dispatch(getPatientVisitDetails(token, params.id));
      toast.success("Visit notes updated successfully");
    } catch (err) {
      toast.error("Visit notes not updated");
    }
    setSaving(false);
  };

  return (
    <div>
      <label style={{ fontWeight: 600, marginBottom: 4, display: "block" }}>
        Notes:
      </label>
      <textarea
        value={note}
        onChange={(e) => setNote(e.target.value)}
        maxLength={200}
        rows={2}
        style={{
          width: "100%",
          borderRadius: 6,
          border: "1px solid #e1e5e9",
          padding: 8,
        }}
        disabled={saving || !editing}
      />
      <div
        style={{
          fontSize: 12,
          marginTop: 2,
        }}
      >
        {`${note.length}/200`}
      </div>
      {editing && (
        <div className="d-flex justify-content-end mt-2">
          <button
            onClick={handleSave}
            disabled={saving}
            className="btn"
            style={{
              backgroundColor: "#092540",
              color: "#fff",
              borderRadius: "6px",
              padding: "6px 16px",
            }}
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
};

export default NotesEditor;
